(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[193],{

/***/ 6193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ApplyLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(7821);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/detect-browser/es/index.js
var es = __webpack_require__(3631);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/OutdatedBrowser/OutdatedBrowser.module.css
var OutdatedBrowser_module = __webpack_require__(5193);
var OutdatedBrowser_module_default = /*#__PURE__*/__webpack_require__.n(OutdatedBrowser_module);
;// CONCATENATED MODULE: ./components/OutdatedBrowser/index.js




function OutdatedBrowser(param) {
    var visible = param.visible;
    var ref = (0,react.useState)(visible), mounted = ref[0], setMounted = ref[1];
    var handleClick = function() {
        setMounted(false);
    };
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OutdatedBrowser_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (OutdatedBrowser_module_default()).title,
                children: "Your browser is out-of-date!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (OutdatedBrowser_module_default()).text,
                children: "Please update your browser to view this website correctly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://browser-update.org/update-browser.html",
                target: "_blank",
                rel: "noopener noreferrer",
                className: (OutdatedBrowser_module_default()).link,
                children: "Update my browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (OutdatedBrowser_module_default()).btn,
                onClick: handleClick
            })
        ]
    });
}
OutdatedBrowser.propTypes = {
    visible: (prop_types_default()).bool
};
OutdatedBrowser.defaultProps = {
    visible: false
};
/* harmony default export */ var components_OutdatedBrowser = (OutdatedBrowser);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(131);
;// CONCATENATED MODULE: ./helpers/scrollTo.js
var easeInOutQuad = function(t, b, c, d) {
    var nT = t / (d / 2);
    if (nT < 1) return c / 2 * nT * nT + b;
    nT -= 1;
    return -c / 2 * (nT * (nT - 2) - 1) + b;
};
var easeInSine = function(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
};
// scrollTo(100); - scroll window to 100
// scrollTo(300, { target: '#layout' }); - scroll div with id 'layout' to 300;
var scrollTo = function(to) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var element = options && options.target ? document.getElementById(options.target) : window;
    // console.log(element);
    var duration = options && options.duration || 500;
    var callback = options && options.callback || null;
    var start = element.scrollTop || element.scrollY;
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    var scrollInterval = null;
    var animateScroll = function() {
        currentTime += increment;
        var val = easeInSine(currentTime, start, change, duration);
        if (element.self === window) {
            window.scrollTo(0, val);
        } else {
            element.scrollTop = val;
        }
        if (currentTime >= duration) {
            clearInterval(scrollInterval);
            if (callback) callback();
        }
    };
    scrollInterval = setInterval(animateScroll, increment);
};
/* harmony default export */ var helpers_scrollTo = (scrollTo);

// EXTERNAL MODULE: ./context/SitesContextProvider.js
var SitesContextProvider = __webpack_require__(9563);
// EXTERNAL MODULE: ./components/Link/index.js + 1 modules
var Link = __webpack_require__(5641);
// EXTERNAL MODULE: ./components/WordpressLink/WordpressLink.module.css
var WordpressLink_module = __webpack_require__(7592);
var WordpressLink_module_default = /*#__PURE__*/__webpack_require__.n(WordpressLink_module);
;// CONCATENATED MODULE: ./components/WordpressLink/index.js










function WordpressLink(_param) {
    var className = _param.className, isExternalLink = _param.isExternalLink, url = _param.url, label = _param.label, children = _param.children, link = _param.link, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isExternalLink",
        "url",
        "label",
        "children",
        "link"
    ]);
    if (isExternalLink) return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: classnames_default()((WordpressLink_module_default()).container, className),
        dangerouslySetInnerHTML: {
            __html: label
        }
    }, props), {
        children: children
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: link.__typename,
        href: link.uri || link.slug,
        className: classnames_default()((WordpressLink_module_default()).container, className)
    }, props), {
        children: children || label
    }));
}
WordpressLink.propTypes = {
    url: (prop_types_default()).string,
    isExternalLink: (prop_types_default()).bool,
    label: (prop_types_default()).string,
    className: (prop_types_default()).string,
    link: (prop_types_default()).object
};
WordpressLink.defaultProps = {
    url: null,
    isExternalLink: false,
    label: null,
    className: null,
    link: null
};
/* harmony default export */ var components_WordpressLink = (WordpressLink);

// EXTERNAL MODULE: ./components/Footer/Footer.module.css
var Footer_module = __webpack_require__(9693);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/Footer/index.js










function Footer(param) {
    var globalSettings = param.globalSettings, className = param.className;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 0.5
    }), 2), ref6 = ref5[0], inView = ref5[1];
    var handleScrollTo = function() {
        helpers_scrollTo(0);
    };
    var ref7 = (globalSettings === null || globalSettings === void 0 ? void 0 : (ref = globalSettings.offices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.acfOffices) || {}, facebookHandle = ref7.facebookHandle, instagramHandle = ref7.instagramHandle, twitterHandle = ref7.twitterHandle;
    var socialLinks = [
        {
            social: "Facebook",
            href: "https://www.facebook.com/",
            handle: facebookHandle
        },
        {
            social: "Instagram",
            href: "https://www.instagram.com/",
            handle: instagramHandle
        },
        {
            social: "Twitter",
            href: "https://twitter.com/",
            handle: twitterHandle
        }, 
    ];
    var footerMenu = (globalSettings === null || globalSettings === void 0 ? void 0 : (ref3 = globalSettings.footerMenu) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.acfMenuItems) === null || ref4 === void 0 ? void 0 : ref4.menu) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "footer",
        className: classnames_default()((Footer_module_default()).container, className, (0,_define_property/* default */.Z)({}, (Footer_module_default()).rotateBtn, inView)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Footer_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).btnWrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: (Footer_module_default()).scrollTopBtn,
                                onClick: handleScrollTo
                            })
                        }),
                        footerMenu === null || footerMenu === void 0 ? void 0 : footerMenu.map(function(m, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).links,
                                children: m === null || m === void 0 ? void 0 : m.items.map(function(props) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordpressLink, (0,_object_spread/* default */.Z)({
                                        className: (Footer_module_default()).link
                                    }, props), "".concat(props.url, "_").concat(props.label));
                                })
                            }, "".concat(m[0]).concat(i));
                        }),
                        socialLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).links,
                            children: socialLinks.filter(function(f) {
                                return f.handle;
                            }).map(function(param, i) {
                                var href = param.href, handle = param.handle, social = param.social;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "".concat(href).concat(handle),
                                    target: "_blank",
                                    rel: "reopener noreferrer",
                                    className: (Footer_module_default()).link,
                                    children: social
                                }, "".concat(handle).concat(i));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: ref6,
                    className: classnames_default()((Footer_module_default()).row, (Footer_module_default()).rowCopy),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Footer_module_default()).copy,
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " select model management"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://patron.studio",
                            target: "_blank",
                            rel: "reopener noreferrer",
                            className: (Footer_module_default()).copy,
                            children: "site by patron"
                        })
                    ]
                })
            ]
        })
    });
}
Footer.propTypes = {
    globalSettings: (prop_types_default()).object,
    className: (prop_types_default()).string
};
Footer.defaultProps = {
    globalSettings: {},
    className: ""
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./components/Layout/Layout.module.css
var Layout_module = __webpack_require__(1627);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./components/Layout/index.js







function Layout(param) {
    var children = param.children, footerLess = param.footerLess, className = param.className, globalSettings = param.globalSettings, contentClassName = param.contentClassName;
    var browser = (0,es/* detect */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OutdatedBrowser, {
                visible: browser && browser.name === "ie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "layout",
                className: classnames_default()((Layout_module_default()).main, contentClassName),
                children: children
            }),
            !footerLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {
                globalSettings: globalSettings
            })
        ]
    });
}
Layout.propTypes = {
    className: (prop_types_default()).string,
    footerLess: (prop_types_default()).bool,
    globalSettings: (prop_types_default()).object,
    contentClassName: (prop_types_default()).string
};
Layout.defaultProps = {
    footerLess: false,
    className: "",
    globalSettings: {},
    contentClassName: ""
};
/* harmony default export */ var components_Layout = (Layout);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/html-entities/lib/index.js
var lib = __webpack_require__(9111);
;// CONCATENATED MODULE: ./helpers/uppercaseFirst.js
function uppercaseFirst(string) {
    if (!string) return null;
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substring(1));
}

// EXTERNAL MODULE: ./helpers/isModellinkSite.js
var isModellinkSite = __webpack_require__(2084);
;// CONCATENATED MODULE: ./components/WordpressSEO/index.js








var htmlEntities = new lib/* Html5Entities */.JK();
function htmlDecode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlEntities.decode(string);
}
// TODO: Set default image url
function WordpressSEO(param) {
    var url = param.url, title = param.title, seo = param.seo, image = param.image, desc = param.desc;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var siteName;
    var fallbackTitle;
    var siteLogo;
    if ((0,isModellinkSite/* default */.Z)()) {
        siteName = "Modellink";
        fallbackTitle = "".concat(htmlDecode(title), " | ").concat(siteName);
        siteLogo = "/img/logo/modellink.jpg";
    } else {
        var ref2;
        siteName = "Select Model Management";
        fallbackTitle = "".concat(htmlDecode(title)).concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.site) ? " | Select ".concat(uppercaseFirst(router.query.site)) : "", " | ").concat(siteName);
        siteLogo = "/img/logo/selectmodel.jpg";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: seo && seo.title ? htmlDecode(seo.title) : fallbackTitle,
        description: (seo === null || seo === void 0 ? void 0 : seo.metaDesc) || desc || siteName,
        openGraph: {
            title: seo === null || seo === void 0 ? void 0 : seo.title,
            url: "".concat(constants/* LIVE_SITE_URL */.WJ).concat(url),
            description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
            images: [
                {
                    url: image || (seo === null || seo === void 0 ? void 0 : (ref = seo.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "".concat(constants/* LIVE_SITE_URL */.WJ).concat(siteLogo)
                }, 
            ]
        }
    });
}
WordpressSEO.propTypes = {
    url: (prop_types_default()).string,
    title: (prop_types_default()).string,
    desc: (prop_types_default()).string,
    image: (prop_types_default()).string,
    seo: (prop_types_default()).object
};
WordpressSEO.defaultProps = {
    url: "",
    title: "",
    desc: null,
    image: "",
    seo: {}
};
/* harmony default export */ var components_WordpressSEO = (WordpressSEO);

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(2286);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/ApplyFlashMessage/ApplyFlashMessage.module.css
var ApplyFlashMessage_module = __webpack_require__(2240);
var ApplyFlashMessage_module_default = /*#__PURE__*/__webpack_require__.n(ApplyFlashMessage_module);
;// CONCATENATED MODULE: ./components/ApplyFlashMessage/index.js





// import clearFlashMessage from '../../actions/flashMessage/clear';

//TODO: Setup proptypes
function ApplyFlashMessage(param) {
    var site = param.site, message = param.message, dispatch = param.dispatch, close = param.close, className = param.className;
    var container = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(null), height = ref1[0], setHeight = ref1[1];
    var ref2 = (0,react.useState)(true), mounted = ref2[0], setMounted = ref2[1];
    var handleScroll = function() {
        var currentScroll = window.pageYOffset;
        if (currentScroll > 0) setVisible(false);
        else setVisible(true);
    };
    var handleResize = function() {
        if (container.current) setHeight(container.current.getBoundingClientRect().height);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        if (container.current) setHeight(container.current.getBoundingClientRect().height);
        return function() {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    });
    // if (!message) return null
    var handleClose = function() {
        (0,dist.setCookie)(null, "flash-message-read", true, {
            sameSite: "strict",
            maxAge: 30 * 24 * 60 * 60
        });
        setMounted(false);
    // dispatch(clearFlashMessage(site.slug))
    // close()
    };
    var show = showFlashMessage();
    if (!mounted) return false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ApplyFlashMessage_module_default()).overlay
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ApplyFlashMessage_module_default()).popup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Important Notice"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Please be aware that individuals are falsely claiming to work for Select Model Management (and they have been using some of our staff names and e-mail signatures)."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "If you are contacted by anyone claiming to represent us, please do not respond without first verifying their identity by promptly calling directly at one of our offices."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ApplyFlashMessage_module_default()).buttons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.selectmodel.com/london/beware-of-scammers/",
                                className: (ApplyFlashMessage_module_default()).infoButton,
                                children: "Find out more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                title: "Close overlay",
                                className: (ApplyFlashMessage_module_default()).continueButton,
                                onClick: handleClose,
                                children: "Continue"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function showFlashMessage() {
    var cookies = (0,dist.parseCookies)();
    if (!cookies["flash-message-read"]) {
        return true;
    }
    return false;
}
/* harmony default export */ var components_ApplyFlashMessage = (dynamic_default()(function() {
    return Promise.resolve(ApplyFlashMessage);
}, {
    ssr: false
}));

// EXTERNAL MODULE: ./components/Logo/index.js
var Logo = __webpack_require__(9213);
// EXTERNAL MODULE: ./components/ApplyHeader/ApplyHeader.module.css
var ApplyHeader_module = __webpack_require__(3800);
var ApplyHeader_module_default = /*#__PURE__*/__webpack_require__.n(ApplyHeader_module);
// EXTERNAL MODULE: ./helpers/getCurrentSiteBusinessUnit.js
var getCurrentSiteBusinessUnit = __webpack_require__(6810);
;// CONCATENATED MODULE: ./components/ApplyHeader/index.js








// import Menu from '../Menu';
// import fetch from '../../../helpers/localStorage';



//TODO: setup proptypes
function ApplyHeader(param) {
    var className = param.className, headerFloat = param.headerFloat, uiColour = param.uiColour, _activeArea = param.activeArea, activeArea = _activeArea === void 0 ? null : _activeArea;
    var ref = (0,react.useState)(null), activeFlashMessage = ref[0], setActiveFlashMessage = ref[1];
    var _obj;
    // useEffect(
    //   () => {
    //     const closedFlashMessages = fetch('flashMessagesClosed', []);
    //     // console.log('qweqwe', cxlosedFlashMessages);
    //     if (globalMessage && !closedFlashMessages.includes(page.slug)) {
    //       setActiveFlashMessage(globalMessage);
    //     }
    //   },
    //   [globalMessage, page.slug],
    // );
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ApplyHeader_module_default()).container, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (ApplyHeader_module_default()).containerFloat, headerFloat), (0,_define_property/* default */.Z)(_obj, (ApplyHeader_module_default()).containerSteps, activeArea !== null), _obj), className),
        children: [
            !activeArea && !(0,isModellinkSite/* default */.Z)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ApplyFlashMessage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ApplyHeader_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        className: (ApplyHeader_module_default()).logo,
                        colour: "#fff",
                        href: constants/* LIVE_SITE_URL */.WJ,
                        businessUnit: (0,getCurrentSiteBusinessUnit/* default */.Z)()
                    }),
                    !(0,isModellinkSite/* default */.Z)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: classnames_default()((ApplyHeader_module_default()).menu, (0,_define_property/* default */.Z)({}, (ApplyHeader_module_default()).menuDark, uiColour === "dark")),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                type: "Apply",
                                href: "start",
                                className: classnames_default()((ApplyHeader_module_default()).link, (0,_define_property/* default */.Z)({}, (ApplyHeader_module_default()).linkActive, activeArea === "form")),
                                children: "Apply"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                type: "Apply",
                                href: "open-call",
                                className: classnames_default()((ApplyHeader_module_default()).link, (0,_define_property/* default */.Z)({}, (ApplyHeader_module_default()).linkActive, activeArea === "open-call")),
                                children: "Open Call"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                type: "Apply",
                                href: "advice",
                                className: classnames_default()((ApplyHeader_module_default()).link, (0,_define_property/* default */.Z)({}, (ApplyHeader_module_default()).linkActive, activeArea === "advice")),
                                children: "Advice"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_ApplyHeader = (ApplyHeader);

// EXTERNAL MODULE: ./components/ApplyLayout/ApplyLayout.module.css
var ApplyLayout_module = __webpack_require__(4322);
var ApplyLayout_module_default = /*#__PURE__*/__webpack_require__.n(ApplyLayout_module);
;// CONCATENATED MODULE: ./components/ApplyLayout/index.js










//TODO: setup proptypes
function ApplyLayout(_param) {
    var _headerFloat = _param.headerFloat, headerFloat = _headerFloat === void 0 ? false : _headerFloat, uiColour = _param.uiColour, activeArea = _param.activeArea, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "headerFloat",
        "uiColour",
        "activeArea",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Layout, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()((ApplyLayout_module_default()).container, className),
        footerLess: true
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordpressSEO, {
                url: "https://apply.selectmodel.com",
                title: "Apply | Become a Model | Select Model Management",
                desc: "Select Model Management",
                seo: {
                    images: [
                        {
                            url: "".concat(constants/* LIVE_SITE_CMS */.ye, "/wp-content/uploads/2020/06/marielu-e1591267898727.jpg")
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ApplyHeader, {
                activeArea: activeArea,
                headerFloat: headerFloat,
                uiColour: uiColour
            }),
            children
        ]
    }));
}
/* harmony default export */ var components_ApplyLayout = (ApplyLayout);


/***/ }),

/***/ 5641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./helpers/generateRoute.js
var cleanSlug = function(slug) {
    return slug.replace(/^\/|\/$/g, "");
};
var generateRoute = function(link) {
    var pathPrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var slug = cleanSlug(link.slug);
    switch(link.type){
        case "Model":
            return {
                href: "/[site]/model/[modelSlug]",
                as: "/".concat(pathPrefix, "/model/").concat(slug)
            };
        case "BoardModel":
            return {
                href: "/[site]/[boardType]/[boardSlug]/[modelSlug]",
                as: "/".concat(pathPrefix, "/").concat(slug)
            };
        case "Board":
        case "ModelBoard":
            return {
                href: "/[site]/[boardType]/[boardSlug]",
                as: "/".concat(pathPrefix, "/").concat(slug)
            };
        case "Article":
        case "Post":
            return {
                href: "/[site]/article/[slug]",
                as: "/".concat(pathPrefix, "/article/").concat(slug)
            };
        case "Page":
            {
                if (slug === "home" || slug === "") return {
                    href: "/[site]",
                    as: "/".concat(pathPrefix)
                };
                var special = [
                    "contact",
                    "about",
                    "news"
                ];
                return {
                    href: "/[site]/".concat(special.includes(slug) ? slug : "[...slug]"),
                    as: "/".concat(pathPrefix, "/").concat(slug)
                };
            }
        case "Site":
            return {
                href: "/[site]",
                as: "/".concat(slug)
            };
        case "Terms":
            {
                return {
                    href: "/[site]/[...slug]",
                    as: "/".concat(pathPrefix, "/").concat(slug)
                };
            }
        // case 'Office':
        //   return {
        //     href: `/[site]/office/[slug]`,
        //     as: `${currentSite}office/`,
        //   }
        // case 'Showcase':
        //   return {
        //     href: `/[site]/showcase/[slug]`,
        //     as: `${currentSite}showcase/`,
        //   }
        case "Category":
            return {
                href: "/[site]/news/[categorySlug]",
                as: "/".concat(pathPrefix, "/news/").concat(slug)
            };
        case "Highlight":
            return {
                href: "/[site]/highlight/[slug]",
                as: "/".concat(pathPrefix, "/highlight/").concat(slug)
            };
        case "Apply":
            {
                if (slug === "advice") return {
                    href: "/[slug]",
                    as: "/".concat(slug)
                };
                if (slug.includes("/")) return {
                    href: "/open-call/[slug]",
                    as: "/".concat(slug)
                };
                return {
                    href: "/".concat(slug),
                    as: "/".concat(slug)
                };
            }
        case "Collections":
            return {
                href: "/".concat(slug),
                as: "/".concat(slug)
            };
        case "API":
            return {
                href: "/api/".concat(slug),
                as: "/api/".concat(slug)
            };
        default:
            {
                if (!slug.includes("collections")) console.error("Possible error: generateRoute not found type", link);
                return {
                    href: "/".concat(slug),
                    as: "/".concat(slug)
                };
            }
    }
};
/* harmony default export */ var helpers_generateRoute = (generateRoute);

// EXTERNAL MODULE: ./context/SitesContextProvider.js
var SitesContextProvider = __webpack_require__(9563);
// EXTERNAL MODULE: ./components/Link/Link.module.css
var Link_module = __webpack_require__(3581);
var Link_module_default = /*#__PURE__*/__webpack_require__.n(Link_module);
;// CONCATENATED MODULE: ./components/Link/index.js








function LinkInternal(param) {
    var initialHref = param.href, label = param.label, children = param.children, className = param.className, type = param.type, _site = param.site, site = _site === void 0 ? null : _site;
    var currentSite = (0,react.useContext)(SitesContextProvider/* SitesContext */.y).currentSite;
    var ref = helpers_generateRoute({
        type: type,
        slug: initialHref
    }, site || currentSite ? currentSite.path.replace(/\//g, "") : null), href = ref.href, as = ref.as;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        as: as,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((Link_module_default()).container, className),
            children: children || label
        })
    });
}
LinkInternal.propTypes = {
    href: (prop_types_default()).string,
    as: (prop_types_default()).string,
    label: (prop_types_default()).string,
    className: (prop_types_default()).string,
    type: (prop_types_default()).string
};
LinkInternal.defaultProps = {
    href: "",
    as: "",
    label: null,
    className: "",
    type: null
};
/* harmony default export */ var Link = (LinkInternal);


/***/ }),

/***/ 9213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5641);
/* harmony import */ var _Logo_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5506);
/* harmony import */ var _Logo_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Logo_module_css__WEBPACK_IMPORTED_MODULE_3__);





function Logo(param) {
    var businessUnit = param.businessUnit, colour = param.colour, className = param.className, href = param.href;
    var content = businessUnit === "modellink" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 120 23",
        className: "aq8IK",
        fill: colour,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                        points: ".004 .243 13.214 .243 13.214 12.853 .004 12.853"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                        points: ".156 .278 12.706 .278 12.706 22.662 .156 22.662"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                        points: ".091 .243 11.902 .243 11.902 12.853 .091 12.853"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                        points: "0 22.878 119.978 22.878 119.978 0 0 0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(25.412 10.025)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.38171765,6.54776176 C2.38171765,8.77639412 4.25724706,10.6752471 6.60924706,10.6752471 C8.96089412,10.6752471 10.8367765,8.77639412 10.8367765,6.54776176 C10.8367765,4.29443824 8.96089412,2.42061471 6.60924706,2.42061471 C4.25724706,2.42061471 2.38171765,4.29443824 2.38171765,6.54776176 M13.2141882,6.54776176 C13.2141882,10.1181735 10.3080706,12.8531441 6.60924706,12.8531441 C2.91042353,12.8531441 0.0036,10.1181735 0.0036,6.54776176 C0.0036,2.97768824 2.91042353,0.243055882 6.60924706,0.243055882 C10.3080706,0.243055882 13.2141882,2.97768824 13.2141882,6.54776176"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(41.294 .216)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10.4593765,16.3314882 C10.4593765,14.0274294 9.00667059,12.0775029 6.44361176,12.0775029 C3.98608235,12.0775029 2.53302353,14.1285618 2.53302353,16.3314882 C2.53302353,18.5597824 3.93384706,20.6362088 6.44361176,20.6362088 C9.03278824,20.6362088 10.4593765,18.6612529 10.4593765,16.3314882 Z M10.3277294,20.4082382 L10.2747882,20.4082382 C9.32361176,21.7503559 7.81796471,22.6619 6.07337647,22.6619 C2.26902353,22.6619 0.155611765,19.6489 0.155611765,16.2553853 C0.155611765,13.0140765 2.40067059,10.0518118 5.96784706,10.0518118 C7.81796471,10.0518118 9.29714118,10.9633559 10.2747882,12.3812382 L10.3277294,12.3812382 L10.3277294,0.278164706 L12.7058471,0.278164706 L12.7058471,22.2566941 L10.3277294,22.2566941 L10.3277294,20.4082382 Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(57.53 10.025)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.52376471,5.18061471 C9.23294118,3.40826176 8.01776471,2.21801176 6.11576471,2.21801176 C4.26564706,2.21801176 2.89129412,3.48402647 2.60117647,5.18061471 L9.52376471,5.18061471 Z M2.46882353,6.90257059 C2.49494118,8.92792353 3.92258824,10.8271147 6.19447059,10.8271147 C8.01776471,10.8271147 8.99576471,9.94093824 9.894,8.52305588 L11.9018824,9.61183529 C10.7389412,11.6628941 8.57258824,12.8531441 6.16764706,12.8531441 C2.38941176,12.8531441 0.0907058824,10.1181735 0.0907058824,6.62420294 C0.0907058824,2.97768824 2.12541176,0.243055882 6.11576471,0.243055882 C10.0517647,0.243055882 11.9018824,3.02842353 11.9018824,6.54776176 L11.9018824,6.90257059 L2.46882353,6.90257059 Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                points: "73.079 22.472 75.457 22.472 75.457 .494 73.079 .494"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                points: "79.994 22.472 82.372 22.472 82.372 .494 79.994 .494"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M87.138 22.4723529L89.5161176 22.4723529 89.5161176 10.6222794 87.138 10.6222794 87.138 22.4723529zM89.9650588 5.20341176C89.9650588 6.06455882 89.2249412 6.74813235 88.3267059 6.74813235 87.4284706 6.74813235 86.6887059 6.06455882 86.6887059 5.20341176 86.6887059 4.31723529 87.4284706 3.60829412 88.3267059 3.60829412 89.2249412 3.60829412 89.9650588 4.31723529 89.9650588 5.20341176zM96.5885647 12.2176L96.6408 12.2176C97.3809176 10.9512471 98.8604471 10.2676735 100.366447 10.2676735 103.854565 10.2676735 104.753153 12.5209971 104.753153 15.4081735L104.753153 22.4722176 102.375035 22.4722176 102.375035 15.6862029C102.375035 13.66085 102.084212 12.2933647 99.6535059 12.2933647 96.5885647 12.2933647 96.5885647 14.8757912 96.5885647 17.0286588L96.5885647 22.4722176 94.2108 22.4722176 94.2108 10.6221441 96.5885647 10.6221441 96.5885647 12.2176z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                points: "111.655 15.079 116.305 10.622 119.449 10.622 114.165 15.535 119.978 22.472 116.886 22.472 112.474 17.079 111.655 17.864 111.655 22.472 109.277 22.472 109.277 .494 111.655 .494"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                points: "10.809 15.973 0 0 0 22.524 2.484 22.524 2.484 7.91 10.809 20.921 19.133 7.91 19.133 22.524 21.617 22.524 21.617 0"
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1116.9 285.8",
        fill: colour,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M194,184.8C176.7,197,150.9,203,116.5,203,45.4,203,6.4,185.6,0,150.9L77,143c.3,3.5,4.5,7.6,12.6,11.9a50.2,50.2,0,0,0,26,6.8c21,0,35.6-7,35.6-18.7,0-9.5-8.7-15.5-25.8-18.5l-73-12.7c-30-5.2-44.8-23.6-44.8-55.1C7.6,38,16.8,23.6,35,14.1S76.4,0,104.7,0c36.7,0,62.7,4.3,78.7,12.8Q214,29,216.4,51.3l-72.8,4.1c-4.2-9.5-15.4-16.9-33.3-16.9-22.1,0-32.7,8.4-32.7,17.1s5,12.8,15.1,14.4l77,13c33.6,5.7,50.1,20.9,50.1,55.9C219.8,157.6,211.1,172.8,194,184.8Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M299,135.4c1.4,15.5,16.5,29.6,42,29.6,20.5,0,29.7-3.8,38.4-14.7l67.5,8.2c-14.9,24.7-51.6,43.9-106.7,43.9-31.4,0-57.1-7-77.3-20.9s-30.5-33.1-30.5-57.8q0-34.2,30.2-53.7c20.2-13,46.5-19.5,79.3-19.5,70.2,0,111.1,29.8,112.5,84.9Zm84.6-26.9q-4.7-25.2-42-25.2-35.7,0-42.9,25.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "cls-1",
                d: "M535.6,196.4H471.2V6.5h64.4Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M616.3,135.4c1.4,15.5,16.5,29.6,42,29.6,20.4,0,29.6-3.8,38.3-14.7l67.5,8.2c-14.8,24.7-51.5,43.9-106.7,43.9q-46.9,0-77.3-20.9c-20.4-13.8-30.5-33.1-30.5-57.8q0-34.2,30.3-53.7c20.1-13,46.4-19.5,79.2-19.5,70.3,0,111.2,29.8,112.6,84.9Zm84.5-26.9q-4.6-25.2-42-25.2-35.7,0-42.8,25.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M999.3,151.1C980,185.3,942.4,202.4,887,202.4c-53.8,0-106.9-24.1-106.9-78.4,0-51.3,50.6-73.5,106.9-73.5,58.5,0,94.9,13.8,110.6,49.4l-65.8,6.5c-9-14.4-19.3-21.2-44-21.2a42.8,42.8,0,0,0-29.4,11.1c-8.1,7.3-12.3,16.3-12.3,26.9,0,25.8,15.7,42,42.6,42,12,0,21-1.6,26.6-5.1s11.7-9.5,18.2-18.7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1116.9,96.1h-25.2v52.6c0,12.7,3.6,13.8,18.5,13.8h6.1v35.6a303.9,303.9,0,0,1-35,1.6c-24.3,0-35.8-1.4-43.7-9.2s-8.9-16.8-8.9-38.3V96.1h-18.8V59.2h18.8V14.7h63V59.2h25.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M75.6,284.7H67.7v-9.1c0-7,.1-12.1.2-15.6h-.1c-.9,2.2-2.3,5.4-4.4,9.4l-7.6,15.3H49.6l-6.9-13.5A108,108,0,0,1,37.5,260h-.1c.1,4.5.2,9.6.2,15.4v9.3H29.7V248.9H39l8.3,15.8A95,95,0,0,1,52.7,276h.1c.6-1.7,2.4-5.6,5.5-11.7l8-15.4h9.3Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M116.5,250.3a27.4,27.4,0,0,1,11.9-2.5c5.7-.1,12.7,1.7,17.7,6,3.2,2.7,5.4,7.4,5.4,12.9,0,14.1-12.7,19.1-23.1,19.1s-22.8-5.3-22.8-19C105.6,258.1,110.5,252.8,116.5,250.3Zm1.4,26.1c2.6,2.3,6.1,3.5,10.5,3.5a16,16,0,0,0,10.7-3.5c2.7-2.3,4-5.4,4-9.6a12.5,12.5,0,0,0-3.9-9.7c-2.7-2.3-6.3-3.5-10.8-3.5s-8.4,1.2-10.8,3.7a13.2,13.2,0,0,0-3.6,9.5A12.4,12.4,0,0,0,117.9,276.4Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M197.6,284.7H181.5V248.9h15.4q22.5,0,22.5,17.4C219.4,278.6,212.1,284.7,197.6,284.7Zm-1.5-29.8h-6.7v23.6h7c9.8,0,14.7-4,14.7-12.1S206.1,254.9,196.1,254.9Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M285,284.7H249.3V248.9h34.4v6H257.3v8.4H281v5.9H257.3v9.3H285Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "cls-1",
                d: "M345,284.7H314.9V248.9h8v29.6H345Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M463.5,284.7h-7.9v-9.1c0-7,.1-12.1.2-15.6h-.1a84.6,84.6,0,0,1-4.4,9.4l-7.6,15.3h-6.2l-6.9-13.5c-2.3-4.6-4.1-8.3-5.2-11.2h-.1c.1,4.5.3,9.6.3,15.4v9.3h-8V248.9h9.3l8.3,15.8a95,95,0,0,1,5.4,11.3h.1a115.1,115.1,0,0,1,5.6-11.7l8-15.4h9.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M491.7,284.7l17.6-35.8h8.3l17.9,35.8h-8.9l-4-8.3H504l-4,8.3Zm21.4-28.2-6.3,13.9h12.9l-6.5-13.9Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M602,284.7h-7.3l-14.3-15.3c-5-5.4-8-8.7-9-10.1h-.1c.2,2.8.3,8.5.3,17v8.4h-7.9V248.9h7.2l14.4,15.5,8.9,9.8h.1q-.3-5.2-.3-15.3v-10h8Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M630.1,284.7l17.6-35.8H656l17.9,35.8h-8.8l-4.1-8.3H642.4l-4,8.3Zm21.4-28.2-6.3,13.9h12.9l-6.5-13.9Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M734.7,258.9c-2.8-3.5-7-5.3-12.7-5.3a15.1,15.1,0,0,0-10.2,3.4c-2.7,2.2-4.1,5.5-4.1,9.8a12.5,12.5,0,0,0,4,9.6,15.2,15.2,0,0,0,10.2,3.5q6.1,0,9.9-3c2.4-2,3.7-4,3.8-6.1v-.2h-12v-5.5H743v19.6h-7.3v-4.2h-.1a19,19,0,0,1-13.7,5.2,27.6,27.6,0,0,1-15.5-4.4c-4.3-3-7.1-8.1-7.1-14.5a16.6,16.6,0,0,1,3.2-10.3,19.1,19.1,0,0,1,8.3-6.5,29,29,0,0,1,11.2-2.1c5.8,0,10.9,1.3,14.2,3.3a20.6,20.6,0,0,1,6.8,6Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M810.3,284.7H774.6V248.9h34.3v6H782.6v8.4h23.7v5.9H782.6v9.3h27.7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M886.1,284.7h-7.9v-9.1c0-7,.1-12.1.2-15.6h-.1a84.6,84.6,0,0,1-4.4,9.4l-7.6,15.3h-6.2l-6.9-13.5c-2.3-4.6-4.1-8.3-5.2-11.2h-.1c.1,4.5.2,9.6.2,15.4v9.3h-7.9V248.9h9.3l8.3,15.8a95,95,0,0,1,5.4,11.3h.1a115.1,115.1,0,0,1,5.6-11.7l8-15.4h9.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M953,284.7H917.4V248.9h34.3v6H925.4v8.4H949v5.9H925.4v9.3H953Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1021.3,284.7H1014l-14.3-15.3c-5-5.4-8-8.7-9-10.1h-.1c.2,2.8.3,8.5.3,17v8.4H983V248.9h7.3l14.3,15.5,8.9,9.8h.1q-.3-5.2-.3-15.3v-10h8Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1087.2,255h-14.4v29.7h-8V255h-14.4v-6.1h36.8Z"
            })
        ]
    });
    var setClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Logo_module_css__WEBPACK_IMPORTED_MODULE_3___default().container), className);
    if (!href) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: setClass,
        children: content
    });
    return href.startsWith("http") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: setClass,
        children: content
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        type: "Site",
        className: setClass,
        children: content
    });
}
Logo.propTypes = {
    small: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    colour: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Logo.defaultProps = {
    small: false,
    colour: "#000",
    className: null,
    href: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 2240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ApplyFlashMessage_spacing--xxxs__22gE8","spacing--xxs":"ApplyFlashMessage_spacing--xxs__WArvK","spacing--xs":"ApplyFlashMessage_spacing--xs__2N7_J","spacing--sm":"ApplyFlashMessage_spacing--sm__8YMj_","spacing--md":"ApplyFlashMessage_spacing--md__pxGJ1","spacing--lg":"ApplyFlashMessage_spacing--lg__TJ631","spacing--xl":"ApplyFlashMessage_spacing--xl__3dQT_","spacing--xxl":"ApplyFlashMessage_spacing--xxl__ja5hm","spacing--xxxl":"ApplyFlashMessage_spacing--xxxl__sLyjE","overlay":"ApplyFlashMessage_overlay__e2ITa","popup":"ApplyFlashMessage_popup__HDwO7","buttons":"ApplyFlashMessage_buttons__94Ux2","infoButton":"ApplyFlashMessage_infoButton__LaJZ3","continueButton":"ApplyFlashMessage_continueButton__WCC17","fadeInItems":"ApplyFlashMessage_fadeInItems__SpHK_"};

/***/ }),

/***/ 3800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ApplyHeader_spacing--xxxs__CKqyn","spacing--xxs":"ApplyHeader_spacing--xxs__3LwCe","spacing--xs":"ApplyHeader_spacing--xs__mqjpa","spacing--sm":"ApplyHeader_spacing--sm__HQwZ2","spacing--md":"ApplyHeader_spacing--md__RyedL","spacing--lg":"ApplyHeader_spacing--lg__jXgCv","spacing--xl":"ApplyHeader_spacing--xl__NyWMz","spacing--xxl":"ApplyHeader_spacing--xxl__FaSo8","spacing--xxxl":"ApplyHeader_spacing--xxxl__Droeq","container":"ApplyHeader_container__5xZCg","containerFloat":"ApplyHeader_containerFloat__JXwgy","containerSteps":"ApplyHeader_containerSteps__NgHUs","wrapper":"ApplyHeader_wrapper__KxY2f","logo":"ApplyHeader_logo__9moQo","menu":"ApplyHeader_menu__aE4JK","menuDark":"ApplyHeader_menuDark__bldXS","link":"ApplyHeader_link__59PA9","linkActive":"ApplyHeader_linkActive__8C9wi","fadeInItems":"ApplyHeader_fadeInItems__U6o04"};

/***/ }),

/***/ 4322:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ApplyLayout_spacing--xxxs__ct9mj","spacing--xxs":"ApplyLayout_spacing--xxs___0_tj","spacing--xs":"ApplyLayout_spacing--xs__VhAFj","spacing--sm":"ApplyLayout_spacing--sm__tjHaw","spacing--md":"ApplyLayout_spacing--md__dVBEZ","spacing--lg":"ApplyLayout_spacing--lg__DCTZO","spacing--xl":"ApplyLayout_spacing--xl__X3r4x","spacing--xxl":"ApplyLayout_spacing--xxl___JVHA","spacing--xxxl":"ApplyLayout_spacing--xxxl__XR28g","container":"ApplyLayout_container__o_lUf","fadeInItems":"ApplyLayout_fadeInItems__CUGs6"};

/***/ }),

/***/ 9693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Footer_spacing--xxxs__CzfKU","spacing--xxs":"Footer_spacing--xxs__zIOHg","spacing--xs":"Footer_spacing--xs__OkOVK","spacing--sm":"Footer_spacing--sm__Ko9Or","spacing--md":"Footer_spacing--md__LZpkr","spacing--lg":"Footer_spacing--lg__9w1YJ","spacing--xl":"Footer_spacing--xl__lCGg_","spacing--xxl":"Footer_spacing--xxl__H0ThZ","spacing--xxxl":"Footer_spacing--xxxl___tgdb","container":"Footer_container__C8cmA","wrapper":"Footer_wrapper__chorF","row":"Footer_row__Iq0h_","rowCopy":"Footer_rowCopy__XG9UT","btnWrap":"Footer_btnWrap__VYW_t","scrollTopBtn":"Footer_scrollTopBtn__ac_ek","rotateBtn":"Footer_rotateBtn__3RQJv","links":"Footer_links__fUg_J","link":"Footer_link__zqu3E","copy":"Footer_copy__tBQbn","fadeInItems":"Footer_fadeInItems__FTUMp"};

/***/ }),

/***/ 1627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Layout_spacing--xxxs__8iHw7","spacing--xxs":"Layout_spacing--xxs__rg8b2","spacing--xs":"Layout_spacing--xs__dO6OG","spacing--sm":"Layout_spacing--sm__jhGe9","spacing--md":"Layout_spacing--md__vIpF7","spacing--lg":"Layout_spacing--lg__fEe2_","spacing--xl":"Layout_spacing--xl__dhV28","spacing--xxl":"Layout_spacing--xxl__K3sH1","spacing--xxxl":"Layout_spacing--xxxl__Bs9tG","main":"Layout_main__gbdP0","fadeInItems":"Layout_fadeInItems__QzPHk"};

/***/ }),

/***/ 3581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Link_spacing--xxxs__oIPp6","spacing--xxs":"Link_spacing--xxs__KRjoC","spacing--xs":"Link_spacing--xs__c2TKF","spacing--sm":"Link_spacing--sm__pxEyP","spacing--md":"Link_spacing--md__XndO3","spacing--lg":"Link_spacing--lg__B5nKV","spacing--xl":"Link_spacing--xl__tJnmx","spacing--xxl":"Link_spacing--xxl__wWyAg","spacing--xxxl":"Link_spacing--xxxl__cS6fM","container":"Link_container__E8ggp","fadeInItems":"Link_fadeInItems__GxmJY"};

/***/ }),

/***/ 5506:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Logo_spacing--xxxs__BAa2r","spacing--xxs":"Logo_spacing--xxs__PuLcq","spacing--xs":"Logo_spacing--xs__wE5WH","spacing--sm":"Logo_spacing--sm__CQwrZ","spacing--md":"Logo_spacing--md__RVdzV","spacing--lg":"Logo_spacing--lg__STCFB","spacing--xl":"Logo_spacing--xl__KAy0g","spacing--xxl":"Logo_spacing--xxl__3bhDo","spacing--xxxl":"Logo_spacing--xxxl___qp88","container":"Logo_container__IL8K4","logo":"Logo_logo__0605V","fadeInItems":"Logo_fadeInItems__aZOn5"};

/***/ }),

/***/ 5193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OutdatedBrowser_spacing--xxxs__Accab","spacing--xxs":"OutdatedBrowser_spacing--xxs__i92K8","spacing--xs":"OutdatedBrowser_spacing--xs__zWpQI","spacing--sm":"OutdatedBrowser_spacing--sm__Vrmq_","spacing--md":"OutdatedBrowser_spacing--md__vcPS_","spacing--lg":"OutdatedBrowser_spacing--lg__SYnnw","spacing--xl":"OutdatedBrowser_spacing--xl__Mc5r2","spacing--xxl":"OutdatedBrowser_spacing--xxl___59QJ","spacing--xxxl":"OutdatedBrowser_spacing--xxxl__S_A_A","container":"OutdatedBrowser_container__5_uvZ","title":"OutdatedBrowser_title___0088","text":"OutdatedBrowser_text__aSnM3","link":"OutdatedBrowser_link__HM2Bc","btn":"OutdatedBrowser_btn__r3Ac0","fadeInItems":"OutdatedBrowser_fadeInItems__7725t"};

/***/ }),

/***/ 7592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"WordpressLink_spacing--xxxs__ddGyU","spacing--xxs":"WordpressLink_spacing--xxs__BZeEq","spacing--xs":"WordpressLink_spacing--xs__eNWnK","spacing--sm":"WordpressLink_spacing--sm__6jjaq","spacing--md":"WordpressLink_spacing--md__70yqz","spacing--lg":"WordpressLink_spacing--lg__x_iIr","spacing--xl":"WordpressLink_spacing--xl__TuYRB","spacing--xxl":"WordpressLink_spacing--xxl__IyWuI","spacing--xxxl":"WordpressLink_spacing--xxxl__d7trK","container":"WordpressLink_container__tantW","fadeInItems":"WordpressLink_fadeInItems__ptw60"};

/***/ })

}]);